import React from 'react';

const FadeElement: React.FC = (props) => {
  const { children, ...transitionProps } = props;
  return <div {...transitionProps}>{children}</div>;
};

export default FadeElement;
